import { wrapSmartrrSnippet, DelimiterNames } from "./utils";

export const SMARTRR_INCLUDE_ACCOUNT_SNIPPET = wrapSmartrrSnippet(
  `{% render 'smartrr-account' %}`,
  DelimiterNames.DEFAULT
);
